import mirrorCreator from "mirror-creator";

export default mirrorCreator(["SET_CONFIGS"]);
